import SelectAsync from "../SelectAsync";
import { SelectOptionType } from "types/select/SelectOptionType";
import { SingleValue } from "react-select";
import { Col } from "react-bootstrap";
import { api } from "constants/RotasAPI";

interface SelectUnidadesProps {
  condominioId: number | undefined;
  onChange: (opcaoSelecionada: SingleValue<SelectOptionType<any>>) => void;
  size?: number;
  label: string;
  invalidateQuerysKey?: unknown[];
}

const SelectUnidades: React.FC<SelectUnidadesProps> = (props) => {
  return (
    <Col xs={props?.size ?? 3}>
      <SelectAsync
        id="selecionar-unidade"
        nomeAtributoLabel="blocoNumero"
        nomeAtributoValue="id"
        usarValidacaoParaFormulario={false}
        endpoint={`${api.unidade.getRegistrosUnidades}/${props.condominioId}`}
        invalidateQuerysKey={props.invalidateQuerysKey}
        placeholder="Selecione uma unidade"
        label={props.label}
        onChange={props.onChange}
      />
    </Col>
  );
};

export default SelectUnidades;
